export const DestinationStatuses = {
    PUBLISHED: 0,
    DRAFT: 1,
    ARCHIVED: 2,
} as const;
